

















































import { Image } from 'element-ui';
export default {
  name: "GImageItem",
  components: {
    ElImage: Image,
  },
  props: {
    list: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      isView: false,
      currentIndex: null
    }
  },
  methods: {
    /**
     * @description 预览当前图片
     * @param {*} index
     */
    handleReview(index) {
      this.isView = true
      this.currentIndex = index
    },
    handleClose() {
      this.isView = false
      this.currentIndex = null
    },
    handleLink() {
      window.open(this.list[this.currentIndex])
    }
  }
}
